import { TextField } from "@mui/material"
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import axoisInstance from '../../../utils/axiosInstance';
import { toast } from 'sonner';

const ResetPassword = () => {
    const [token, setToken] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const cookies_email = Cookies.get('forgot_password_email');

    const handleReset = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            if (!token || !newPassword) {
                toast.error("Failure! Token and new password are required.");
                setLoading(false);
                return;
            }

            const response = await axoisInstance.post('/auth/resetpassword', {
                email: cookies_email,
                token,
                newPassword
            });

            if (response.status === 200) {
                toast.success("Success! Password has been reset successfully.");
                Cookies.remove('forgot_password_email');
                navigate('/auth/login');
            } else {
                toast.error("Failure! Something went wrong, please try again.");
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    toast.error("Failure! User not found.");
                } else if (error.response.status === 400) {
                    toast.error("Failure! Invalid token or new password.");
                } else {
                    toast.error("Failure! Something went wrong, please try again.");
                }
            } else {
                toast.error("Failure! Network error, please check your connection.");
            }
            console.error("Error resetting password:", error);
        } finally {
            setLoading(false);
        }
    }
    return (
        <div className="flex flex-col items-center justify-center min-h-screen">
            <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
                <h2 className="text-2xl font-bold mb-6 text-center text-blue-800">Reset Password</h2>
                <p className="text-gray-600 mb-4">Enter your new password to reset.</p>
                <form>
                    <div className="mb-4">
                        <div className="flex flex-col mb-4">
                            <label className="text-gray-700 mb-2">Enter Token</label>
                            <TextField type="text" fullWidth required variant="outlined"
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            borderColor: "#e5e7eb",
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "#9ca3af",
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#3b82f6",
                                        },
                                    },
                                    "& .MuiInputBase-input": {
                                        textAlign: "center",
                                        fontSize: "1.125rem",
                                        color: "#111827",
                                        letterSpacing: "0.5rem",
                                    },
                                    "& .MuiInputBase-input::placeholder": {
                                        textAlign: "center",
                                        fontSize: "1.125rem",
                                        opacity: 1,
                                        color: "#6b7280",
                                        letterSpacing: "0.5rem",
                                    },
                                }}
                                InputProps={{
                                    style: { fontSize: "1rem", color: "#374151", textAlign: "center" },
                                }}
                                placeholder="• • • • •"
                                value={token} onChange={(e) => setToken(e.target.value)}
                            />
                        </div>
                        <TextField label="New Password" type="password" fullWidth required variant="outlined" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                    </div>
                    <button type="submit" className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition duration-200" disabled={loading} onClick={handleReset}>Reset Password</button>
                </form>
            </div>
            <div className="text-center mt-4">
                <p className="text-gray-400">Remembered your password? <Link to="/auth/login" className="text-blue-500 hover:text-blue-700">Login</Link></p>
            </div>
        </div>
    )
}

export default ResetPassword
